<template>
	<div class="main">
		<ul class="nav">
			<li v-for="(item, index) in navList" :key="index" :class="{
            active:
              path.indexOf(item.href) > -1 || path.indexOf(item.detail) > -1,
          }">
				<router-link :class="{
            active_text:
              path.indexOf(item.href) > -1 || path.indexOf(item.detail) > -1,
          }" :to="item.base + item.href">{{ item.name }}</router-link>
				<!-- <span class="span-name" @click="goto(item.base + item.href)">{{item.name}}</span> -->
				<!-- <span class="indent" v-if="index != navList.length - 1">丨</span> -->
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: "Navigation",
		props: {
			navList: {
				type: Array,
				required: true, //必填项
			},
		},
		computed: {
			path() {
				return this.$route.path;
			},
		},
		methods: {
			// goto(path) {
			//   this.$router.push(path);
			// }
		},
	};
</script>

<style>
	.nav {
		/* overflow: hidden; */
		background: #fff;
	}

	.nav li {
		line-height: 66px;
		font-size: 16px;
		text-align: center;
		font-weight: 400;
	}

	.nav li a {
		color: #666;
		font-size: 14px;
		width: 100%;
		height: 100%;
		display: block;
	}

	.nav li .span-name {
		cursor: pointer;
	}

	.nav li .indent {
		margin-left: 10px;
		font-size: 20px;
		font-weight: bold;
		color: #000;
	}

	.nav .active {
		border-left: 4px solid #2c6bb0;
	}

	.nav .active_text {
		font-size: 16px;
		color: #2c6bb0;
		font-weight: bold;

	}
</style>
